import { CommissionHistoryMap } from "./commissionHistoryAction";

const initialState = {
  isLoading: false,
  commissionHistoryList: {},
  refreshList: true,
  selectedData: null,
  search: "",
  templates: [],
  searchText: "",
  skip: 0,
  limit: 10,
  commission_type: "",
  status: "",
  fromDate: "",
  toDate: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CommissionHistoryMap.GET_ALL_COMMISSION_HISTORY_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CommissionHistoryMap.GET_ALL_COMMISSION_HISTORY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        commissionHistoryList: action.payload,
        refreshList: false,
      };
    }
    case CommissionHistoryMap.GET_ALL_COMMISSION_HISTORY_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshList: false,
      };
    }

    case CommissionHistoryMap.GET_COMMISSION_HISTORY_START:
      return { ...state, isLoading: true };
    case CommissionHistoryMap.GET_COMMISSION_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedData: action.payload.data,
      };
    case CommissionHistoryMap.GET_COMMISSION_HISTORY_ERROR:
      return {
        ...state,
        isLoading: false,
      };

    case CommissionHistoryMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }

    case CommissionHistoryMap.SELECT_TEXT_CHANGE: {
      return {
        ...state,
        ...action.payload, // Merge the updated fields into the state
        refreshList: true,
      };
    }
    case CommissionHistoryMap.SET_COMMISSION_HISTORY_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshList: true,
      };
    }
    case CommissionHistoryMap.REFRESH_COMMISSION_HISTORY_LIST: {
      return {
        ...state,
        skip: 0,
        refreshList: true,
      };
    }
    case CommissionHistoryMap.SET_TO_DATE_CHANGES: {
      return {
        ...state,
        toDate: action.payload,
        refreshList: true,
      };
    }
    case CommissionHistoryMap.SET_FROM_DATE_CHANGES: {
      return {
        ...state,
        fromDate: action.payload,
        refreshList: true,
      };
    }
    case CommissionHistoryMap.RESET_FILTERS: {
      return {
        ...state,
        toDate: "",
        fromDate: "",
        status: "",
        commission_type: "",
        search: "",
        searchText: "",
        refreshList: true,
      };
    }

    default:
      return { ...state };
  }
};
